<template>
  <section id="rightContent" class="flex-column align-end justify-center">
    <figure class="flex align-center" :class="step5DataClass()">
      <img class="oval relative idx1" :src="base+'/images/common/ring/'+dynamicImage.shape+'/'+dynamicImage.width+'/'+dynamicImage.texture+'_'+dynamicImage.surface+'_'+dynamicImage.width+dynamicImage.milgrain+'.jpg'" alt="image">
      <img id="baseColorImg" class="absolute png idx3" :class="{multiply:dynamicImage.color === 'K18GY'}" :src="base+'/images/common/color/'+dynamicImage.shape+'/'+dynamicImage.width+'/'+dynamicImage.color+'.png'" alt="color ring">

      <!--  outside diamond    -->
      <!-- base -->
      <img v-if="dynamicImage.diamondBase && !['hineridome'].includes(dynamicImage.diamondBase) && step5Check" class="absolute png ajust" :src="base+'/images/common/ring/option/'+dynamicImage.diamondBase+'_small.png'" alt="diamond base">
      <img v-if="dynamicImage.diamondBase && !['hineridome'].includes(dynamicImage.diamondBase) && !step5Check" class="absolute png ajust" :src="base+'/images/common/ring/option/'+dynamicImage.diamondBase+'_large.png'" alt="diamond base">
      <!-- base for hineridome -->
      <img v-if="dynamicImage.diamondBase && ['hineridome'].includes(dynamicImage.diamondBase) && step5Check2 && step2Check" class="absolute png ajust" :src="base+'/images/common/ring/option/'+dynamicImage.diamondBase+'5Base_small.png'" alt="diamond base">
      <img v-if="dynamicImage.diamondBase && ['hineridome'].includes(dynamicImage.diamondBase) && !step5Check2 && step2Check" class="absolute png ajust" :src="base+'/images/common/ring/option/'+dynamicImage.diamondBase+'5Base_large.png'" alt="diamond base">
      <img v-if="dynamicImage.diamondBase && ['hineridome'].includes(dynamicImage.diamondBase) && step5Check2 && !step2Check" class="absolute png ajust" :src="base+'/images/common/ring/option/'+dynamicImage.diamondBase+'7Base_small.png'" alt="diamond base">
      <img v-if="dynamicImage.diamondBase && ['hineridome'].includes(dynamicImage.diamondBase) && !step5Check2 && !step2Check" class="absolute png ajust" :src="base+'/images/common/ring/option/'+dynamicImage.diamondBase+'7Base_large.png'" alt="diamond base">
      <!-- dia -->
      <img v-if="dynamicImage.diamondBase && !['hoshiboriBase', 'taiyoboriBase', 'hineriboriBase','hineridome'].includes(dynamicImage.diamondBase) && step5Check" class="absolute png idx4 ajust no-blend" :src="base+'/images/common/ring/option/'+dynamicImage.diamondBase+'Dia_small.png'" alt="diamond rock">
      <img v-if="dynamicImage.diamondBase && !['hoshiboriBase', 'taiyoboriBase', 'hineriboriBase','hineridome'].includes(dynamicImage.diamondBase) && !step5Check" class="absolute png idx4 ajust no-blend" :src="base+'/images/common/ring/option/'+dynamicImage.diamondBase+'Dia_large.png'" alt="diamond rock">
      <!-- dia for hineridome -->
      <img v-if="dynamicImage.diamondBase && !['hoshiboriBase', 'taiyoboriBase', 'hineriboriBase'].includes(dynamicImage.diamondBase) && ['hineridome'].includes(dynamicImage.diamondBase) && step5Check && step2Check" class="absolute png idx4 ajust no-blend" :src="base+'/images/common/ring/option/'+dynamicImage.diamondBase+'5BaseDia_small.png'" alt="diamond rock">
      <img v-if="dynamicImage.diamondBase && !['hoshiboriBase', 'taiyoboriBase', 'hineriboriBase'].includes(dynamicImage.diamondBase) && ['hineridome'].includes(dynamicImage.diamondBase) && !step5Check && step2Check" class="absolute png idx4 ajust no-blend" :src="base+'/images/common/ring/option/'+dynamicImage.diamondBase+'5BaseDia_large.png'" alt="diamond rock">
      <img v-if="dynamicImage.diamondBase && !['hoshiboriBase', 'taiyoboriBase', 'hineriboriBase'].includes(dynamicImage.diamondBase) && ['hineridome'].includes(dynamicImage.diamondBase) && step5Check && !step2Check" class="absolute png idx4 ajust no-blend" :src="base+'/images/common/ring/option/'+dynamicImage.diamondBase+'7BaseDia_small.png'" alt="diamond rock">
      <img v-if="dynamicImage.diamondBase && !['hoshiboriBase', 'taiyoboriBase', 'hineriboriBase'].includes(dynamicImage.diamondBase) && ['hineridome'].includes(dynamicImage.diamondBase) && !step5Check && !step2Check" class="absolute png idx4 ajust no-blend" :src="base+'/images/common/ring/option/'+dynamicImage.diamondBase+'7BaseDia_large.png'" alt="diamond rock">
      <!-- dia-color -->
      <img v-if="dynamicImage.diamondColor && !['hoshiboriBase', 'taiyoboriBase', 'hineriboriBase'].includes(dynamicImage.diamondBase) && step5Check && dynamicImage.diamondColor!=='transparent'" id="diaColorImg" class="absolute png multiply idx4 ajust" :src="base+'/images/common/ring/option/'+dynamicImage.diamondBase+'/small/'+dynamicImage.diamondColor+'.png'" alt="diamond base">
      <img v-if="dynamicImage.diamondColor && !['hoshiboriBase', 'taiyoboriBase', 'hineriboriBase'].includes(dynamicImage.diamondBase) && !step5Check && dynamicImage.diamondColor!=='transparent'"  id="diaColorImg" class="absolute png multiply idx4 ajust" :src="base+'/images/common/ring/option/'+dynamicImage.diamondBase+'/large/'+dynamicImage.diamondColor+'.png'" alt="diamond base">
      
      <!--  inside diamond   -->
      <img v-if="dynamicImage.innerDiamondBase" class="absolute png idx2 no-blend ajust" :src="base+'/images/common/ring/option/uchigawaBase.png'" alt="inside diamond base">
      <img id="insideDiaColorImg" v-if="dynamicImage.innerDiamondBase" class="absolute png idx4 no-blend ajust gray" :src="base+'/images/common/ring/option/'+dynamicImage.innerDiamondBase+'.png'" alt="inside diamond rock">
      <img id="insideDiaGrayImg" v-if="dynamicImage.innerDiamondBase" class="absolute png idx4 no-blend ajust gray" :src="base+'/images/common/ring/option/uchigawaGray.png'" alt="inside diamond rock">

    </figure>
    <p v-if="route.name !== 'Step11'" class="caution text-right font-gothic">※イメージのため実物と色味が異なる場合がございます。</p>

    <div v-if="route.name !== 'Step11'" class="for-sp">
      <ul class="flex-wrap">
        <li><span class="capitalize">性別:</span> <span class="capitalize">{{query}},</span></li>
        <li v-for="(item, idx) in results" :key="idx">
          <span class="capitalize">{{ "step."+item.step }}:</span>
          <span class="capitalize">{{item.name}},</span>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import {computed, ref} from "vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import useImageBuilder from "../../helpers/useImageBuilder"
import {PATH_HANDLER} from "@/config";
import Loading from "@/components/Loading";
export default {
  name: "RightContent",
  components: {Loading},
  setup(){
    const route = useRoute()
    const query = ref(route.query.gender)
    const store = useStore()
    const {step5Data, step5Check, step5Check2, step2Check} = useImageBuilder()
    
    // for dia position ajust
    function step5DataClass() {
      if(step5Data.value) {
        let forClassName = step5Data.value.replace(".","_");
        return "w" + forClassName
      }
    }

    function stepDataSearch(step){
      const obj = results.value.find(item => {
        return item.step === step
      })
      
      if (step === 5){
        return obj ? obj.val.replace("mm", "") : null
      }
      if (step === 7){
        if (obj){
          obj.val = obj.val.split("_")[0]
          return obj
        } else {
          return null
        }
      } else {
        return obj ? obj : null
      }
    }

    const loading = ref(true)
    setTimeout( () => {
      loading.value = false
    }, 1000)

    const results = computed(() => {
      return store.state.moduleA.results
    })

    const dynamicImage = computed(() => {
     return {
        color:  stepDataSearch(1) ? stepDataSearch(1).val : "PT",
        shape:  stepDataSearch(2) ? stepDataSearch(2).val : "flat",
        texture:  stepDataSearch(3) ? stepDataSearch(3).val : "simple",
        surface:  stepDataSearch(4) ? stepDataSearch(4).val : "gloss",
        width: stepDataSearch(5) ? stepDataSearch(5) : "2.6",
        milgrain: stepDataSearch(6) ? stepDataSearch(6).val : "",
        diamondBase: stepDataSearch(7) ? stepDataSearch(7).val : null,
        diamondColor: stepDataSearch(7) ? stepDataSearch(7).option : null,
        innerDiamondBase: stepDataSearch(8) ? stepDataSearch(8).val : null,
      }
    })



    const base = ref(PATH_HANDLER.path)

    return {route, dynamicImage, loading, base, results, route, query, step5Data, step5Check, step5DataClass, step5Check2, step2Check}
  }
}
</script>

<style scoped>
#rightContent {
  width: 60%;
  height: 100%;
}
#rightContent > figure {
  position: relative;
  width: 100%;
  height: auto;
  max-height: 416px;
  isolation: isolate;
}
#rightContent > figure > img {
  width: 100%;
  margin: auto;
  mix-blend-mode: color;
}
#rightContent > figure > img.multiply {
  mix-blend-mode: multiply;
}
#rightContent > figure > img.no-blend {
  mix-blend-mode: unset;
}
#rightContent > figure> img.absolute {
  left: 0;
  top: 0;
}
#rightContent > p.caution {
  position: relative;
  top: 4px;
  font-size: .8rem;
}

/* for dia position ajust */
#rightContent > figure.w1_8mm> img.absolute.ajust {
  bottom: -4px;
}
#rightContent > figure.w2_0mm> img.absolute.ajust {
  bottom: -2px;
}
#rightContent > figure.w2_2mm> img.absolute.ajust {
  bottom: -2px;
}
#rightContent > figure.w2_4mm> img.absolute.ajust {
  bottom: -2px;
}
/* #rightContent > figure.w2_6mm> img.absolute.ajust {
} */
#rightContent > figure.w2_8mm> img.absolute.ajust {
  bottom: 5px;
}
#rightContent > figure.w3_0mm> img.absolute.ajust {
  bottom: 7px;
}
#rightContent > figure.w3_2mm> img.absolute.ajust {
  bottom: 10px;
}
#rightContent > figure.w3_4mm> img.absolute.ajust {
  bottom: 12px;
}
#rightContent > figure.w3_6mm> img.absolute.ajust {
  bottom: 14px;
}
#rightContent > figure.w3_8mm> img.absolute.ajust {
  bottom: 16px;
}

#rightContent .for-pc {
  display: block;
}
#rightContent .for-sp {
  display: none;
}
#rightContent.gray {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
}
#insideDiaGrayImg {
  display: none;
}
#insideDiaGrayImg.visible {
  display: block;
}

@media screen and (max-width: 736px) {
  #rightContent .for-pc {
    display: none;
  }
  #rightContent .for-sp {
    display: block;
    margin: 20px 0 0;
    padding: 0;
  }
  #leftContent .for-sp > ul {
    list-style-type: none;
    padding: 0 10px;
    margin: 0;
  }
  #leftContent .for-sp > ul > li {
    /* margin-right: 10px; */
    color: gray;
    font-size: 1rem;
    line-height: 1.3;
  }
  #leftContent .for-sp > ul > li > span:nth-child(1) {
    font-size: .9rem;
    margin-right: 5px;
  }
  #leftContent .for-sp > ul > li .capitalize {
      text-transform: capitalize;
  }
}
</style>
